import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectApplicationLoanTags = createSelector(
  selectLoanApplication,
  ({ loanApplicationTags }) => loanApplicationTags ?? [],
);

export const selectApplicationLoanTagsOptions = loanTagsToExclude =>
  createSelector(selectApplicationLoanTags, loanTags => {
    const filteredLoanTags = loanTagsToExclude?.length
      ? loanTags.filter(({ id }) => !loanTagsToExclude.includes(id))
      : loanTags;

    return filteredLoanTags.map(loanTag => ({ ...loanTag, value: loanTag.id }));
  });
